function r(r){return l=>{var n,o;return(null===(n=r.formatters)||void 0===n||null===(o=n[l.route])||void 0===o?void 0:o.call(n,l))||null}}export{r as createLocalRouteFormatter};
//# sourceMappingURL=local.js.map
